import { PropertyTab, useClientProperty } from '../contexts'

import { ClientPropertyMarketingCampaign } from '../../ClientPropertyMarketingCampaign'
import { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { PageTransition } from 'utils/animations'
import { Path } from 'constants/router'
import { useMarketingCampaignAccess } from '../../ClientPropertyMarketingCampaign/useMarketingCampaignAccess'

/**
 * The Marketing campaign tab (epic ISSUE-3615), for the users `useMarketingCampaignAccess` lets in: hidden
 * in the tab bar for the others, whose direct link lands on the visuals gallery. Nothing renders until that
 * is decided, so a user who gets the tab is not bounced on a hard refresh while it loads.
 */
export const ClientPropertyMarketingCampaignPage: FC = () => {
  const { decided, allowed } = useMarketingCampaignAccess()
  const { propertyId } = useClientProperty()

  if (!decided) return null

  if (!allowed) {
    return <Navigate to={Path.PROPERTY_TAB.replace(':id', propertyId).replace(':tab', PropertyTab.GALLERY)} replace />
  }

  return (
    <PageTransition>
      <ClientPropertyMarketingCampaign />
    </PageTransition>
  )
}
